import * as Sentry from '@sentry/capacitor';
import i18n from 'i18next';

export type Language = 'en' | 'es' | 'tl' | 'vi' | 'zh';

export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LANGUAGES = ['en', 'es', 'tl', 'vi', 'zh'] as Language[];

export const setLanguage = async (language: Language): Promise<void> => {
  try {
    await i18n.changeLanguage(language);
  } catch (err) {
    Sentry.captureException(err);
  }
};

/**
 * Maps device language code to supported language code.
 * @param lng - The device language code.
 * @returns The supported language code or undefined if not supported.
 */
export const mapDeviceLangToSupported = (lng: string): string | undefined => {
  return SUPPORTED_LANGUAGES.find((l) => l === lng); // exact match only
};

/*
 * Gets normalized language code from the browser.
 * Examples:
 * "en-US" -> "en"
 * "es-US" -> "es"
 * "zh-HK" -> "zh"
 * "vi-VN" -> "vi"
 * "fil-PH" -> "tl" (Filipino -> Tagalog)
 */
export const getNormalizedLanguageCode = (): string => {
  const langCode = navigator.language.split('-')[0];
  if (langCode === 'fil') return 'tl';
  return langCode;
};
